import { makeAutoObservable, makeObservable, observable } from "mobx"

export default class Debrief {
  Text = ""
  media = null
  isCorrect
  constructor(json, isCorrect) {
    Object.assign(this, json)
    this.isCorrect = isCorrect
  }

  observe() {
      makeObservable(this, {
        Text: observable,
        media: observable,
        isCorrect: observable
      })
    }

}
